export {WAccordion as default} from "./WAccordion";